module.exports = __webpack_public_path__ + "img/ramenohnehintergrund.44ff8463.png";